import { emptyCanvas, normalizeCanvas } from '../../contracts/schemas.js'

function cloneCanvas(canvas) {
  return normalizeCanvas(JSON.parse(JSON.stringify(canvas || emptyCanvas())))
}

export function canvasReducer(state, action) {
  const current = cloneCanvas(state)
  if (!action || typeof action.type !== 'string') return current
  switch (action.type) {
    case 'canvas.replace':
      return cloneCanvas(action.canvas)
    case 'canvas.node.added':
      return { ...current, nodes: [...current.nodes, action.node] }
    case 'canvas.node.updated':
      return {
        ...current,
        nodes: current.nodes.map((node) => node?.id === action.nodeId
          ? { ...node, data: { ...(node.data || {}), ...(action.patch || {}) } }
          : node),
      }
    case 'canvas.nodes.deleted': {
      const ids = new Set(action.nodeIds || [])
      return {
        ...current,
        nodes: current.nodes.filter((node) => !ids.has(node?.id)),
        edges: current.edges.filter((edge) => !ids.has(edge?.from) && !ids.has(edge?.to)),
        groups: current.groups.map((group) => ({ ...group, memberIds: (group.memberIds || []).filter((id) => !ids.has(id)) })).filter((group) => (group.memberIds || []).length >= 2),
      }
    }
    case 'canvas.edge.added':
      return { ...current, edges: [...current.edges, action.edge] }
    case 'canvas.edge.deleted':
      return { ...current, edges: current.edges.filter((edge) => edge?.id !== action.edgeId) }
    case 'canvas.group.added':
      return { ...current, groups: [...current.groups, action.group] }
    case 'canvas.group.deleted':
      return { ...current, groups: current.groups.filter((group) => group?.id !== action.groupId) }
    default:
      return current
  }
}

export function createCanvasStore(initial = emptyCanvas()) {
  let state = cloneCanvas(initial)
  const listeners = new Set()
  const history = []
  const future = []
  function notify() { listeners.forEach((listener) => listener(state)) }
  function replace(next, record = true) {
    const value = cloneCanvas(next)
    if (JSON.stringify(value) === JSON.stringify(state)) return state
    if (record) {
      history.push(state)
      future.length = 0
    }
    state = value
    notify()
    return state
  }
  function dispatch(action) { return replace(canvasReducer(state, action)) }
  return {
    getState: () => cloneCanvas(state),
    dispatch,
    replace(next) { return replace(next) },
    subscribe(listener) { listeners.add(listener); return () => listeners.delete(listener) },
    undo() { if (!history.length) return state; future.push(state); return replace(history.pop(), false) },
    redo() { if (!future.length) return state; history.push(state); return replace(future.pop(), false) },
  }
}
